// "어떤 에러끼리 같은 이슈로 묶을지" 의 기준값을 만든다. 메시지로 묶으면 가변값 때문에 쪼개지거나
// 모든 API 가 한 덩어리로 뭉치므로, API 는 status·method·경로 템플릿, 코드 버그는 도구의 스택
// 자동 그룹핑에 맡긴다(undefined).

import type { AppError } from './AppError'

const UNKNOWN = 'unknown'

const byKind = (error: AppError): string[] | undefined => {
  const method = error.method ?? UNKNOWN
  const route = error.route ?? UNKNOWN

  if (error.kind === 'API') {
    return [error.status === undefined ? UNKNOWN : String(error.status), method, route]
  }
  if (error.kind === 'network') return ['network', error.code ?? UNKNOWN, method, route]
  return error.code ? [error.code] : undefined
}

// 결제도 같은 기준으로 나누고 앞에 payment 만 붙인다. code 하나로만 묶으면 모든 POD 타임아웃·결제 화면의
// 서로 다른 코드 버그가 한 이슈로 뭉쳐, 새 버그가 생겨도 새 이슈(=알림)가 안 생긴다.
export const fingerprint = (error: AppError): string[] | undefined => {
  const base = byKind(error)
  if (error.flow !== 'payment' || !base) return base
  return ['payment', ...base]
}
